import React, { useEffect, useState } from "react";
import "./popup.css";
import { RESET_TIME } from "../../utils/consts";

interface PopupProps {
  showPopup: boolean;
  closePopup: () => void;
}

const Popup: React.FC<PopupProps> = ({ showPopup, closePopup }) => {
  const [timer, setTimer] = useState<number>(RESET_TIME);

  useEffect(() => {
    if (showPopup) {
      if (timer > 0) {
        const timerId = setTimeout(() => {
          setTimer(timer - 1);
        }, 1000);
        return () => clearTimeout(timerId);
      }
    }
    return () => setTimer(RESET_TIME);
  }, [timer, showPopup]);

  const closeAndContinue = () => {
    setTimer(RESET_TIME);
    closePopup();
  };

  return (
    <>
      {showPopup ? (
        <div className="puBackground">
          <div className="puPopup">
            <p
              style={{
                fontWeight: "bold",
                fontSize: "2dvw",
                marginTop: 0,
              }}
            >
              Are you still there?
            </p>
            <i style={{ fontSize: "1.1dvw" }}>
              If not, we will return to the Dartmouth map page in:
            </i>
            <p style={{ fontSize: "1.1dvw" }}>{timer} seconds...</p>
            <div className="puButton" onClick={closeAndContinue}>
              Yes, I&apos;m still here!
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Popup;
